import backspaceHandler from './backspace-handler';
import checkpointDelayHandler from './checkpoint-delay-handler';
import deleteHandler from './delete-handler';
import keyUpHandler from './key-up-handler';
import returnHandler from './return-handler';
import pasteHandler from './paste-handler';
import spaceHandler from './space-handler';
import copyHandler from './copy-handler';

export default {
  backspaceHandler,
  checkpointDelayHandler,
  deleteHandler,
  keyUpHandler,
  returnHandler,
  pasteHandler,
  spaceHandler,
  copyHandler,
};
